import { useQuery } from "@tanstack/react-query";
import {
  fetchPayoutCurrentMonth,
  fetchPayoutPeriodEvents,
  fetchPayoutPeriods,
  fetchPayoutStatus,
} from "../utils/affiliateApi";

export const useAffiliatePayoutStatus = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["affiliate", "payouts", "status"],
    queryFn: () => fetchPayoutStatus(),
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const useAffiliatePayoutCurrentMonth = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["affiliate", "payouts", "current-month"],
    queryFn: () => fetchPayoutCurrentMonth(),
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const useAffiliatePayoutPeriods = ({ limit = 12, offset = 0, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["affiliate", "payouts", "periods", { limit, offset }],
    queryFn: () => fetchPayoutPeriods({ limit, offset }),
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const useAffiliatePayoutPeriodEvents = ({ periodId, enabled = true } = {}) => {
  return useQuery({
    queryKey: ["affiliate", "payouts", "period-events", { periodId }],
    queryFn: () => fetchPayoutPeriodEvents(periodId),
    enabled: enabled && periodId != null,
    refetchOnWindowFocus: false,
  });
};
